import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { motion } from "framer-motion";
import { addDataToFirestore } from '../addData';
import { useTheme } from '../contexts/ThemeContext';

const HireMe = () => {
    const form = useRef();
    const { isDark } = useTheme();

    const sendEmail = (e) => {
        e.preventDefault();

        const data = {
            name: form.current.name.value,
            email: form.current.email.value,
            message: form.current.message.value,
            timestamp: new Date().toISOString()
        }

        addDataToFirestore(data, 'works')

        emailjs.sendForm('service_hcqtol8', 'template_no01lbb', form.current, '_o3xmXeuL9SAjDhil')
        .then((result) => {
            console.log(result.text);
            alert("Your message has been received. Please keep an eye on your email. Will get back to you within few hours.");
            window.location.reload();
        }, (error) => {
            console.log(error.text);
        });
    };

    return (
        <div className='flex-1 flex items-center justify-center py-12 md:py-20 px-4'>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="w-full max-w-2xl"
            >
                {/* Terminal-style form container */}
                <div className={`rounded-lg border overflow-hidden ${
                    isDark
                        ? 'bg-dark-bg-card border-dark-border'
                        : 'bg-light-bg-card border-light-border shadow-lg'
                }`}>
                    {/* Terminal header */}
                    <div className={`px-4 py-3 border-b font-mono text-sm flex items-center gap-2 ${
                        isDark
                            ? 'bg-dark-bg-tertiary border-dark-border'
                            : 'bg-light-bg-tertiary border-light-border'
                    }`}>
                        {/* Window dots */}
                        <div className="flex gap-1.5">
                            <div className={`w-3 h-3 rounded-full ${isDark ? 'bg-red-500' : 'bg-red-400'}`}></div>
                            <div className={`w-3 h-3 rounded-full ${isDark ? 'bg-yellow-500' : 'bg-yellow-400'}`}></div>
                            <div className={`w-3 h-3 rounded-full ${isDark ? 'bg-green-500' : 'bg-green-400'}`}></div>
                        </div>
                        <span className={isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}>
                            $ contact_form.sh
                        </span>
                    </div>

                    {/* Form content */}
                    <form ref={form} onSubmit={sendEmail} className="p-6 md:p-8">
                        {/* Title */}
                        <div className="mb-8">
                            <h2 className={`font-mono font-bold text-2xl md:text-3xl mb-2 ${
                                isDark ? 'text-dark-text-primary' : 'text-light-text-primary'
                            }`}>
                                <span className={isDark ? 'text-dark-brand-primary' : 'text-light-brand-primary'}>
                                    $
                                </span>
                                {' '}get_in_touch
                            </h2>
                            <p className={`font-mono text-sm ${
                                isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                            }`}>
                                <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                                    //
                                </span>
                                {' '}Fill out the form below to contact me
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* Name Input */}
                            <div className="col-span-1">
                                <label className={`font-mono text-sm mb-2 block ${
                                    isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                                }`}>
                                    <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                                        &gt;
                                    </span>
                                    {' '}Name
                                </label>
                                <input
                                    type="text"
                                    id="contact-form-name"
                                    name='name'
                                    required
                                    placeholder="John Doe"
                                    className={`w-full px-4 py-3 rounded-lg border font-mono text-sm transition-all focus:outline-none focus:ring-2 ${
                                        isDark
                                            ? 'bg-dark-bg-tertiary border-dark-border text-dark-text-primary placeholder-dark-text-muted focus:ring-dark-brand-primary focus:border-dark-brand-primary'
                                            : 'bg-light-bg-tertiary border-light-border text-light-text-primary placeholder-light-text-muted focus:ring-light-brand-primary focus:border-light-brand-primary'
                                    }`}
                                />
                            </div>

                            {/* Email Input */}
                            <div className="col-span-1">
                                <label className={`font-mono text-sm mb-2 block ${
                                    isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                                }`}>
                                    <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                                        &gt;
                                    </span>
                                    {' '}Email
                                </label>
                                <input
                                    type="email"
                                    id="contact-form-email"
                                    name='email'
                                    required
                                    placeholder="john@example.com"
                                    className={`w-full px-4 py-3 rounded-lg border font-mono text-sm transition-all focus:outline-none focus:ring-2 ${
                                        isDark
                                            ? 'bg-dark-bg-tertiary border-dark-border text-dark-text-primary placeholder-dark-text-muted focus:ring-dark-brand-primary focus:border-dark-brand-primary'
                                            : 'bg-light-bg-tertiary border-light-border text-light-text-primary placeholder-light-text-muted focus:ring-light-brand-primary focus:border-light-brand-primary'
                                    }`}
                                />
                            </div>

                            {/* Message Input */}
                            <div className="col-span-1 md:col-span-2">
                                <label className={`font-mono text-sm mb-2 block ${
                                    isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                                }`}>
                                    <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                                        &gt;
                                    </span>
                                    {' '}Message
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="6"
                                    required
                                    placeholder="Tell me about your project..."
                                    className={`w-full px-4 py-3 rounded-lg border font-mono text-sm transition-all focus:outline-none focus:ring-2 resize-none ${
                                        isDark
                                            ? 'bg-dark-bg-tertiary border-dark-border text-dark-text-primary placeholder-dark-text-muted focus:ring-dark-brand-primary focus:border-dark-brand-primary'
                                            : 'bg-light-bg-tertiary border-light-border text-light-text-primary placeholder-light-text-muted focus:ring-light-brand-primary focus:border-light-brand-primary'
                                    }`}
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="col-span-1 md:col-span-2">
                                <motion.button
                                    type="submit"
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                    className={`w-full py-3 px-6 rounded-lg font-mono font-semibold text-sm md:text-base transition-all border-2 ${
                                        isDark
                                            ? 'bg-dark-brand-primary text-dark-bg-primary border-dark-brand-primary hover:bg-transparent hover:text-dark-brand-primary'
                                            : 'bg-light-brand-primary text-white border-light-brand-primary hover:bg-transparent hover:text-light-brand-primary'
                                    }`}
                                >
                                    $ execute_send
                                </motion.button>
                            </div>
                        </div>
                    </form>
                </div>
            </motion.div>
        </div>
    )
}

export default HireMe
